<template>
    <div></div>
</template>

<script>
    export default {
        mounted() {
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('remembered');
            this.$router.push('/');
        }
    }
</script>
